import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Product, ColorFilter } from 'src/app/modals/product.model';
import { SharedMethods } from 'src/app/components/shared/services/sharedMethods-service';
import { ScrollService } from 'src/app/components/shared/services/scroll.service';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'app-product-left-sidebar',
  templateUrl: './product-left-sidebar.component.html',
  styleUrls: ['./product-left-sidebar.component.sass']
})
export class ProductLeftSidebarComponent implements OnInit {
  public sidenavOpen:boolean = true;
  public animation    :   any;   // Animation
  public sortByOrder  :   string = '';   // sorting
  public page:any;
  public tagsFilters  :   any[] = [];
  public viewType: string = 'grid';
  public viewCol: number = 20;
  public colorFilters :   ColorFilter[] = [];

  public items        :   Product[] = [];
  public allItems: Product[] = [];
  public products: Product[] = [];
  public tags         :   any[] = [];
  public colors       :   any[] = [];

  public showSpinner = false;

  priceFrom = 100;
  priceTo = 10000;

  nbrresultByPage = 10
  nbrresult = 0
  numpage = 1;
  term: string;
  idcat: string;
  type: string;

  // tslint:disable-next-line:max-line-length
  constructor(private scrollService: ScrollService, private productService: ProductService, private route: ActivatedRoute, private sharedMethods: SharedMethods) {

    this.route.queryParams.subscribe(queryparams => {
      this.term = queryparams['q'];
      this.idcat = queryparams['cat'];
      this.type = queryparams['type'];
      this.ngOnInit();
    });

    // let query: string;
    // query = this.route.snapshot.paramMap.get('q');
    /* this.route.queryParams.subscribe(queryparams => {
        query = queryparams['q'];
        this.route.params.subscribe(
          (params: Params) => {

            const category = params['category'];

            if( this.productService.cacheProduct.length === 0) {

              this.showSpinner = true;
              this.productService.getProducts().subscribe(products => {

                this.productService.cacheProduct = products;
                this.allItems = this.productService.getProductByCategory(this.productService.cacheProduct, category, undefined, query);
                this.products = this.productService.cacheProduct.slice(0.8);
                this.getTags(this.productService.cacheProduct);
                this.getColors(this.productService.cacheProduct);
                this.getPrices(this.productService.cacheProduct);
                this.showSpinner = false;

              },
              err => {
                this.showSpinner = false;
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              })

            } else {

                this.allItems = this.productService.getProductByCategory(this.productService.cacheProduct, category, undefined, query);
                this.products = this.productService.cacheProduct.slice(0.8);
                this.getTags(this.productService.cacheProduct);
                this.getColors(this.productService.cacheProduct);
                this.getPrices(this.productService.cacheProduct);

            }

          }
        )
    }); */

  }



  // Get current product tags
  public getTags(products) {

      var uniqueBrands = []
      var itemBrand = Array();

      products.map((product, index) => {
         if(product.tags) {
            product.tags.map((tag) => {
            const index = uniqueBrands.indexOf(tag);
            if(index === -1)  uniqueBrands.push(tag);
         })
        }
      });

      for (var i = 0; i < uniqueBrands.length; i++) {
           itemBrand.push({brand:uniqueBrands[i]})
      }
      this.tags = itemBrand
  }

  // Get current product colors
  public getColors(products) {
      var uniqueColors = []
      var itemColor = Array();
      products.map((product, index) => {
        if(product.colors) {
        product.colors.map((color) => {
            const index = uniqueColors.indexOf(color);
            if(index === -1)  uniqueColors.push(color);
        })
       }
      });
      for (var i = 0; i < uniqueColors.length; i++) {
           itemColor.push({color:uniqueColors[i]})
      }
      this.colors = itemColor
  }

  // Get prices
  public getPrices(products: Product[]) {

    products.sort(function(a, b) {

      if (a.price > b.price)
        return 1;
      if (a.price < b.price)
        return -1;
      // a doit être égal à b
      return 0;

      // return a.id - b.id;
    });

    if(products !== null && products !== undefined && products.length !== 0 ) {
      this.priceFrom = products[0].price;
      this.priceTo = products[products.length-1].price;
    }

    // on reordonne par id
    products.sort(function(a, b) {

      if (a.id > b.id)
        return -1;
      if (a.id < b.id)
        return 1;
      // a doit être égal à b
      return 0;

      // return a.id - b.id;
    });

  }


  ngOnInit() {


    this.loadProduct();


  }



  loadProduct() {

    this.showSpinner = true;

    // tslint:disable-next-line:max-line-length
    this.productService.search('true', 'true', this.nbrresultByPage, this.numpage, this.term, this.idcat, this.type).subscribe( data=>{
      // console.log(data);
      /* this.products = [];
      data.forEach(element => {
        // this.products.unshift(this.sharedMethods.createProduct(element));
        this.products.push(this.sharedMethods.createProduct(element));
      }); */

      this.nbrresult = data.nbr;

      const rfg: any[] = data.result;
      // on se rassure que la partie decimal est toujours pris en compte
      this.allItems = plainToClass(Product, rfg);
      this.showSpinner = false;
    },
    err => {

      this.showSpinner = false;
      this.sharedMethods.errorApiShow(err.error.code, err.error.message);

    });

  }


  public changeViewType(viewType, viewCol){
    this.viewType = viewType;
    this.viewCol = viewCol;
  }

  // Animation Effect fadeIn
  public fadeIn() {
      this.animation = 'fadeIn';
  }

  // Animation Effect fadeOut
  public fadeOut() {
      this.animation = 'fadeOut';
  }

    // Update tags filter
    public updateTagFilters(tags: any[]) {
      this.tagsFilters = tags;
      this.animation == 'fadeOut' ? this.fadeIn() : this.fadeOut(); // animation
  }



    // sorting type ASC / DESC / A-Z / Z-A etc.
    public onChangeSorting(val) {
      this.sortByOrder = val;
      this.animation == 'fadeOut' ? this.fadeIn() : this.fadeOut(); // animation
   }

     // Initialize filetr Items
  public filterItems(): Product[] {
    return this.items.filter((item: Product) => {
        const Colors: boolean = this.colorFilters.reduce((prev, curr) => { // Match Color
          if(item.colors){
            if (item.colors.includes(curr.color)) {
              return prev && true;
            }
          }
        }, true);
        const Tags: boolean = this.tagsFilters.reduce((prev, curr) => { // Match Tags
          if(item.tags) {
            if (item.tags.includes(curr)) {
              return prev && true;
            }
          }
        }, true);
        return Colors && Tags; // return true
    });

}

public onPageChanged(event){
  /* this.page = event;
  this.allItems; */
  this.numpage = event;
  this.loadProduct();
  this.scrollService.scrollToTop();
}


  // Update price filter
//   public updatePriceFilters(price: any) {
//     let items: any[] = [];
//     this.products.filter((item: Product) => {
//         if (item.price >= price[0] && item.price <= price[1] )  {
//            items.push(item); // push in array
//         }
//     });
//     this.items = items;
// }


  // Update price filter
  public updatePriceFilters(price: any) {
    console.log(price);
    console.log(this.products);


   this.allItems = this.products.filter((item: Product) => {
     return item.price >= price.priceFrom && item.price <= price.priceTo
    });

    // console.log(this.products);

}

onBrendsChanged(newBrend) {
  console.log(newBrend);
  this.allItems = newBrend === 'all' ? this.products : this.products.filter(

    item => item.brand === newBrend
  )
  console.log(this.allItems);


}
}
